<template>
  <el-drawer
  :title="$t('credit_notes.calculator.title')"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :append-to-body="true"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form v-model="calculator" label-position="top">
      <el-row>
        <el-col>
          <el-form-item>
            <span>{{ $t('credit_notes.calculator.originalPrice') }} {{$n(calculator.original_price, 'currency',this.currency)}}</span>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item :label="$t('credit_notes.calculator.value')">
            <el-input-number v-model="calculator.value"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item :label="$t('credit_notes.calculator.type')">
            <el-select v-model="calculator.type" @change="handleTypeSelection">
              <el-option
                v-for="item in types"
                :key="item"
                :label="$t('credit_notes.'+item)"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item :label="$t('credit_notes.calculator.finalAmount')">
          <span>{{$n(calculatedValue,'currency',currency)}}</span>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
  <div class="dialog-footer card-shadow--large">
    <el-button @click="handleClose">{{$t('common.Cancel')}}</el-button>
    <el-button type="primary" @click="save">{{$t('common.apply')}}</el-button>
  </div>
</el-drawer>
</template>
<script>

export default {
  name: 'credit-note-price-calculator',
	props: {
    original_price : { type : Number},
    type : {type : String, default : 'PERCENT'},
    value : {type : Number, default : 100},
    amount : {type : Number},
    visible : {type : Boolean},
    currency : {
      type : String,
      default : 'CAD'
    },
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      calculator : {
        original_price : null,
        type : 'PERCENT',
        value : 100,
        amount : 0.00,
      },
      types : ['PERCENT','NET'],
      loading : false,
      window: {
        width: 0,
        height: 0
      }
    };
  },components: {

  },
  watch : {

  },
	methods: {
    handleTypeSelection(){
      if(this.calculator.type=="PERCENT"){
        this.calculator.value = 100;
      }else{
        this.calculator.value = this.original_price
      }
    },
    save(){
      this.calculator.amount = this.calculatedValue;
      this.$emit('apply',this.calculator);
      this.handleClose();
    },
    open(){
      this.calculator.original_price = this.original_price;
      this.calculator.type = this.type;
      this.calculator.value = this.value;
      this.calculator.amount = this.amount;
    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    // ...mapActions('inventoryProducts', ['fetchSelectedProduct','fetchInventory'])
	},
	computed: {
    calculatedValue(){
      if(this.calculator.type!=null && this.calculator.value!=null && this.calculator.original_price!=null){
        if(this.calculator.type==="PERCENT"){
          return Math.round((this.calculator.original_price * (this.calculator.value/100))*100)/100;
        }else{
          return this.calculator.value;
        }
      }else{
        return 0.00;
      }

    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "30%";
      }else{
        return "100%"
      }
    }
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:60px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
